import { Button } from "@/components/ui/Button"
import { useSEO } from "@/hooks/useSEO"
import { Link } from "@tanstack/react-router"
import { motion } from "framer-motion"
import { ArrowRight, Home } from "lucide-react"

export function NotFoundPage() {
  useSEO({
    title: "404 — Page not found",
    description: "The page you're looking for doesn't exist.",
  })

  return (
    <section className="bg-surface grid-bg relative flex min-h-screen items-center justify-center overflow-hidden">
      <div className="hero-glow" aria-hidden="true" />
      <div className="relative px-6 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-display text-border mb-0 text-[160px] leading-none select-none sm:text-[220px]">
            404
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="relative -mt-8"
        >
          <h1 className="font-display mb-4 text-4xl tracking-tight sm:text-5xl">Page not found</h1>
          <p className="text-muted mx-auto mb-10 max-w-sm text-lg">
            The page you're looking for has been moved or doesn't exist.
          </p>
          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <Button variant="primary" size="lg" asChild>
              <Link to="/">
                <Home className="h-4 w-4" />
                Back to home
              </Link>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <Link to="/contact">
                Contact support <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
